import { useState, useEffect } from 'react';
import firebase from 'firebase/app';

const LIMIT = 400;

function toStartOfDay(date) {
    if (!date) return null;
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
}

function toEndOfDay(date) {
    if (!date) return null;
    const d = new Date(date);
    d.setHours(23, 59, 59, 999);
    return d;
}

export function useClaimedTags({ startDate, endDate, limit = LIMIT } = {}) {
    const [tags, setTags] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const db = firebase.firestore();
        let query = db.collection('tags');

        const normalizedStart = toStartOfDay(startDate);
        const normalizedEnd = toEndOfDay(endDate);

        if (normalizedStart) {
            query = query.where('createdAt', '>=', firebase.firestore.Timestamp.fromDate(normalizedStart));
        }
        if (normalizedEnd) {
            query = query.where('createdAt', '<=', firebase.firestore.Timestamp.fromDate(normalizedEnd));
        }

        query = query.orderBy('createdAt', 'desc').limit(limit);

        const unsubscribe = query.onSnapshot(
            (snapshot) => {
                const list = [];
                snapshot.forEach((doc) => {
                    const data = doc.data();
                    if (data.clientId) {
                        list.push({ ...data, id: doc.id });
                    }
                });
                setTags(list);
                setLoading(false);
            },
            (err) => {
                console.error('useClaimedTags error:', err);
                setTags([]);
                setLoading(false);
            }
        );

        return () => unsubscribe();
    }, [
        startDate ? new Date(startDate).getTime() : null,
        endDate ? new Date(endDate).getTime() : null,
        limit,
    ]);

    return [loading, tags];
}
